<mat-card (click)="openTaskDetailDialog()" class="widget">
  <div class="task-content" slot="content">
    <div class="image-container">
      <svg
        width="60" height="64" viewBox="0 0 60 64"
        [ngClass]="{'completed': completedCount > 0}">
        <!-- Svg (d:) data from assets/images/Taak.svg -->
        <path d="M30 0C30.575 0 31.15 0.125 31.675 0.3625L55.2125 10.35C57.9625 11.5125 60.0125 14.225 60 17.5C59.9375 29.9 54.8375 52.5875 33.3 62.9C31.2125 63.9 28.7875 63.9 26.7 62.9C5.1625 52.5875 0.0624958 29.9 -4.179e-06 17.5C-0.0125042 14.225 2.0375 11.5125 4.7875 10.35L28.3375 0.3625C28.85 0.125 29.425 0 30 0Z"/>
      </svg>
      <span>{{numberInList}}</span>
    </div>
    <div class="points">
      <img
        src="assets/images/sebbies/Spots-3.png"
        height="80px"
        width="160px"
        alt="Sebbies"
        />
        @if (task.reward) {
          <span>{{task.reward || 0}}</span>
        }
      </div>
    </div>
  </mat-card>